'use client';

import React from 'react';
import Image from 'next/image';

interface FullscreenOverlayProps {
  visible: boolean;
  onClose?: () => void;
  children?: React.ReactNode;
  className?: string;
}

export function FullscreenOverlay({
  visible,
  onClose,
  children,
  className = '',
}: FullscreenOverlayProps) {
  if (!visible) return null;

  return (
    <div
      className={`fixed inset-0 z-[80] flex items-center justify-center ${className}`}
      role="dialog"
      aria-modal="true"
      onClick={onClose}
    >
      {/* Background visual layer with requested effects, separated so children stay sharp */}
      <div
        className="absolute inset-0"
        style={{
          backdropFilter: 'blur(100px)',
          WebkitBackdropFilter: 'blur(100px)', // For Safari/iOS support
        }}
      />

      {/* Close button */}
      <button
        type="button"
        aria-label="Close"
        onClick={(e) => {
          e.stopPropagation();
          onClose?.();
        }}
        className="absolute top-5 right-5 w-12 h-12 rounded-full bg-black/40 text-white flex items-center justify-center shadow-lg hover:bg-black/60 hover:scale-110 hover:shadow-xl transition-all duration-200 ease-in-out"
      >
        <Image
          src="/game_ui/close-button.svg"
          alt="Close"
          width={48}
          height={48}
          className="hover:brightness-110 transition-all duration-200"
        />
      </button>

      {/* Foreground content */}
      <div
        className="relative pointer-events-auto w-full max-w-[960px] px-4"
        onClick={(e) => e.stopPropagation()}
      >
        {children}
      </div>
    </div>
  );
}

export default FullscreenOverlay;
